import type { OngoingDownload } from '@mimir/client-common/model/ongoingDownload';
import type { KeldaRequestAdminGetResponseDto } from '@mimir/common/dto/keldaRequestDtos';
import type { MonitoredTransfer } from '@mimir/common/dto/transferRequestDtos';
import { reactive, vueDelete, vueSet } from '../compat/vueCompat';
import { getKeldaRequests, deleteKeldaRequest as apiDeleteKeldaRequest } from '@mimir/web/api/globalClientKelda';
import { getTransfers } from '../util/api';
import { logErrorAndShowToast } from '../util/uiError';


interface TransferState {
  ongoingDownloads: Record<string, OngoingDownload>;
  ongoingTransfers: MonitoredTransfer[] | null,
  ongoingKeldaRequests: Record<string, KeldaRequestAdminGetResponseDto> | null,
}

export const transfer: TransferState = reactive({
  ongoingDownloads: {},
  ongoingTransfers: null,
  ongoingKeldaRequests: null,
});

export function clearOngoingKeldaRequests() {
  transfer.ongoingKeldaRequests = null;
}

export async function fetchOngoingTransfers(supportTenantId?: string) {
  try {
    const transfers = await getTransfers(supportTenantId);
    transfer.ongoingTransfers = transfers;
  } catch (err) {
    logErrorAndShowToast('Failed to load ongoing transfers.', err, 'ex in fetchOngoingTransfers');
  }
}


export async function fetchOngoingKeldaRequests(supportTenantId?: string) {
  try {
    const keldaRequests = await getKeldaRequests(supportTenantId);
    //context.commit('addToOngoingKeldaRequests', keldaRequests);
    if (transfer.ongoingKeldaRequests === null) {
      transfer.ongoingKeldaRequests = {};
    }
    const ongoingRequests = transfer.ongoingKeldaRequests;
    for (const request of keldaRequests) {
      vueSet(ongoingRequests, request.id, { ...ongoingRequests[request.id], ...request });
    }

  } catch (err) {
    logErrorAndShowToast('Failed to load ongoing Kelda requests.', err, 'ex in fetchOngoingKeldaRequests');
  }
}


export async function deleteKeldaRequest(requestId: string, supportTenantId?: string) {
  try {
    await apiDeleteKeldaRequest(requestId, supportTenantId);
    vueDelete(transfer.ongoingKeldaRequests ?? {}, requestId);
  } catch (err) {
    logErrorAndShowToast('Failed to delete Kelda request', err, 'ex in deleteKeldaRequest');
  }
}
